import { createSlice, Draft, PayloadAction, Slice } from '@reduxjs/toolkit';

interface EntityWithId {
  id: number | string; // <-- must have an ID (number or string)
}

const  createGenericSlice = <T>(entityName: string): Slice<T[]> => {

    const initialState = [] as T[]; // <-- force initialState as T[]

const slice = createSlice({

  name: entityName,
  initialState,
  reducers: {
    // Action to add a new invoice
    addItem: (state, action: PayloadAction<T>) => {
        state.push(action.payload as unknown as Draft<T>);
    },

    // Action to edit an existing invoice
    editItem: (state, action: PayloadAction<T>) => {
      const { id } = action.payload as T & EntityWithId;
      const index = state.findIndex((item: any) => item.id === id);
      if (index !== -1) {
        state[index] = action.payload  as unknown as Draft<T>;
      }
    },

    // Action to delete an invoice by IDn

    deleteItem: (state, action: PayloadAction<{ id: number | string }>) => {
      return state.filter((item: any) => item.id !== action.payload.id);
    },

    // Action to copy an invoice
    copyItem: (
      state,
      action: PayloadAction<{id: string | number ; data: T}>
    ) => {
      const { id, data } = action.payload;
      const indexOfMatchingInvoice = state.findIndex((item: Draft<T>) => (item as T & EntityWithId).id === id);
      if (indexOfMatchingInvoice !== -1) {
        state.splice(indexOfMatchingInvoice + 1, 0, data  as unknown as Draft<T>);
      } else {
        state.push(data  as unknown as Draft<T>);
      }
    },

    clearItems: (state) => {
      state.length = 0;
    },

  },
});

return slice;

}

export default createGenericSlice;